// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"8d0cbe06","21":"b8ee402a","146":"9e7c3904","195":"2479361d","506":"c604848d","511":"4d1584cb","672":"85414d61","676":"faabf574","741":"cf6f7f93","775":"65c2db50"}[chunkId] + ".chunk.js";
};